import { NavLink, useNavigate, Link } from "react-router-dom";
import { Moon, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function DashShell({ brandLabel, links, children, rightSlot }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <header className="bg-white border-b border-[#E5E1D8] sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Link to="/" className="flex items-center gap-2">
              <span className="w-8 h-8 rounded-full grid place-items-center bg-[#F3EFE9]"><Moon size={15} className="text-[#9F634E]" /></span>
              <span className="font-display text-[#1A1918] text-[15px]">{brandLabel}</span>
            </Link>
            <nav className={`hidden ${links.length > 9 ? "" : "md:flex"} items-center gap-1`}>
              {links.map(([to, label, end]) => to ? (
                <NavLink key={to} to={to} end={end} data-testid={`dnav-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  className={({ isActive }) => `px-3 py-1.5 rounded-full text-sm transition-colors ${isActive ? "bg-[#9F634E]/10 text-[#9F634E]" : "text-[#6B665E] hover:bg-[#F9F8F6]"}`}>{label}</NavLink>
              ) : null)}
            </nav>
          </div>
          <div className="flex items-center gap-4">
            {rightSlot}
            <span className="hidden sm:block text-xs text-[#6B665E]">{user?.email}</span>
            <button onClick={async () => { await logout(); nav("/"); }} className="text-[#6B665E] hover:text-[#1A1918]"><LogOut size={18} /></button>
          </div>
        </div>
        {links.length > 9 && (
          <nav className="hidden md:flex flex-wrap items-center gap-y-1 max-w-7xl mx-auto px-5 sm:px-8 pb-2" data-testid="dnav-grouped">
            {links.reduce((g, l) => { if (!l[0]) g.push([l]); else g[g.length - 1].push(l); return g; }, [[]]).filter((g) => g.length).map((g, gi) => (
              <div key={gi} className="flex items-center gap-1 whitespace-nowrap">
                {g.map(([to, label, end]) => to ? (
                  <NavLink key={to} to={to} end={end} data-testid={`dnav-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                    className={({ isActive }) => `px-3 py-1 rounded-full text-[13px] transition-colors ${isActive ? "bg-[#9F634E]/10 text-[#9F634E]" : "text-[#6B665E] hover:bg-[#F9F8F6]"}`}>{label}</NavLink>
                ) : (
                  <span key={label} className={`${gi ? "ml-3 pl-3 border-l border-[#E5E1D8]" : ""} mr-1 text-[10px] uppercase tracking-[0.14em] text-[#8A998C]`}>{label}</span>
                ))}
              </div>
            ))}
          </nav>
        )}
        <nav className="md:hidden flex overflow-x-auto no-scrollbar px-4 pb-2 gap-1">
          {links.filter(([to]) => to).map(([to, label, end]) => (
            <NavLink key={to} to={to} end={end} className={({ isActive }) => `px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${isActive ? "bg-[#9F634E]/10 text-[#9F634E]" : "text-[#6B665E]"}`}>{label}</NavLink>
          ))}
        </nav>
      </header>
      {user?.role === "admin" && window.location.pathname.startsWith("/operator") && (
        <div data-testid="consultant-view-banner" className="bg-[#161514] text-[#F7F5F0] text-center text-xs sm:text-sm py-2 px-4">
          TEST MODE — CERTIFIED INFANT SLEEP CONSULTANT VIEW · You're previewing the consultant workspace as the owner · <Link to="/owner" className="underline text-[#C2836B]">Back to Owner</Link>
        </div>
      )}
      <main className="max-w-7xl mx-auto px-5 sm:px-8 py-8">{children}</main>
    </div>
  );
}
